
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(756|790|953)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
